export class EmailFormModel {
    
    name: string = "";
    email: string = "";
    message: string = "";
}